import axios from 'axios';

// filter dropdown
const filterDropdown = document.querySelectorAll('.filter-dropdown');
const partnersFilter = document.querySelector('#partners-filter');

if (filterDropdown && partnersFilter) {
	filterDropdown.forEach((filter) => {
		let currentFilter = filter.querySelector('.filter-dropdown__current');
		let currentFilterSlug = currentFilter.getAttribute('data-slug');
		let filterItems = filter.querySelectorAll('.menu-item');
		// add selected class
		filter.querySelector(`.menu-item[data-slug="${currentFilterSlug}"]`).classList.add('selected');
		// open menu and close menu if click outside filter el
		currentFilter.addEventListener('click', (event) => {
			filter.classList.add('active');
		});
		let filterListener = function(event) {
			closeFilterDropdown(event, filter, filterListener);
		}
		document.addEventListener('click', filterListener, true);
		// update dropdown with new selected filter and close menu
		filterItems.forEach((item) => {
			item.addEventListener('click', (event) => {
				let newFilterSlug = item.getAttribute('data-slug');
				let newFilterName = item.textContent;
				currentFilter.setAttribute('data-slug', newFilterSlug);
				currentFilter.querySelector('span').textContent = newFilterName;
				filter.querySelector('.menu-item.selected').classList.remove('selected');
				document.querySelector('input[name="partner_category"]').value = newFilterSlug;
				item.classList.add('selected');
				filter.classList.remove('active');
				partnersFilterSubmit();
			});
		});
	});

	// ajax to retrieve new partner logos
	let loader = document.createElement('div');
	loader.className = 'lds-ellipsis';
	loader.appendChild(document.createElement('div'));
	loader.appendChild(document.createElement('div'));
	loader.appendChild(document.createElement('div'));
	loader.appendChild(document.createElement('div'));	
	function partnersFilterSubmit() {
		let formData = new FormData(partnersFilter);
		partnersFilter.classList.add('ajaxing');
		partnersFilter.querySelector('.filter-dropdown__current').append(loader);
		formData.append('action', 'partners_filter');
		// form ajax
		axios.post( ajaxurl, formData )
		.then( response => {
			// console.log(response);
			// remove ajax and loader
			partnersFilter.classList.remove('ajaxing');
			loader.remove();
			document.querySelector('.partners-cards__wrapper').innerHTML = response.data.partners;
		})
		.catch( error => {
			console.log(error);
			partnersFilter.classList.remove('ajaxing');
		})
	}
}

function closeFilterDropdown(event, filter, filterListener) {
	let targetEl = event.target;
	do {
		if (targetEl == filter) {
			// console.log('Clicked inside!');
			return;
		}
		// Go up the DOM
		targetEl = targetEl.parentNode;
	}
	while (targetEl);
	// console.log('Clicked outside!');
	filter.classList.remove('active');
	// document.removeEventListener('click', filterListener, true);
}
